import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './Button';
import { ArrowRightIcon, LockIcon, SmartphoneIcon, CreditCardIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="pricing" className="py-14 px-6 bg-burgundy relative overflow-hidden" data-id="element-118">
      <div className="max-w-6xl mx-auto relative z-10" data-id="element-119">
        <div className="grid lg:grid-cols-2 gap-8 items-center" data-id="element-120">
          {/* Left side: Includes */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6
        }} className="text-cream" data-id="element-121">
            <p className="text-gold font-bold uppercase tracking-widest text-sm mb-3" data-id="element-122">
              Tu inversión en claridad
            </p>
            <h2 className="text-3xl md:text-4xl font-bold mb-8 font-serif" data-id="element-123">
              El Salto de
              <br data-id="element-124" />
              <span className="text-gold italic" data-id="element-125">Novia a Esposa</span>
            </h2>

            <ul className="space-y-3 mb-8" data-id="element-126">
              {['eBook completo (7 capítulos)', '12 scripts de conversación exactos', 'Plan de retirada estratégica (14 días)', 'Plan de decisión (30 días)', 'BONUS: El Método Lucía', 'Acceso inmediato en cualquier dispositivo'].map((item, i) => <li key={i} className="flex items-center gap-3 text-base" data-id="element-127">
                  <span className="text-gold font-bold" data-id="element-128">✓</span>
                  <span data-id="element-129">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Right side: Price Box */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream p-6 md:p-10 rounded-2xl shadow-2xl border-4 border-gold text-center relative" data-id="element-130">
            <div className="absolute top-0 right-0 bg-gold text-burgundy font-bold px-5 py-1.5 rounded-bl-2xl uppercase tracking-widest text-xs shadow-md" data-id="element-131">
              Oferta Especial
            </div>

            <p className="text-gray-600 mb-2 mt-3 text-base" data-id="element-132">
              Valor real:{' '}
              <span className="line-through decoration-burgundy/50" data-id="element-133">
                $97 USD
              </span>
            </p>

            <div className="text-5xl md:text-6xl font-bold text-burgundy mb-3 flex items-start justify-center font-serif" data-id="element-134">
              <span className="text-2xl mt-2 mr-1" data-id="element-135">$</span>
              18.95
              <span className="text-lg mt-auto mb-1 ml-2 text-gray-500 font-sans" data-id="element-136">
                USD
              </span>
            </div>

            <p className="text-gray-600 font-medium mb-6" data-id="element-137">
              Pago único · Acceso de por vida
            </p>

            <Button className="w-full text-base px-6 py-5 shadow-xl hover:shadow-2xl flex items-center justify-center gap-3 mb-6" data-id="element-138">
              <span className="text-[14px]" data-id="element-139">
                Quiero transformarme en una mujer de alto valor ahora
              </span>
              <ArrowRightIcon className="w-5 h-5" data-id="element-140" />
            </Button>

            <div className="flex flex-wrap justify-center gap-3 text-xs text-gray-600 font-medium" data-id="element-141">
              <div className="flex items-center gap-1.5" data-id="element-142">
                <LockIcon className="w-4 h-4 text-burgundy" data-id="element-143" />
                <span data-id="element-144">Pago 100% seguro</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-145">
                <SmartphoneIcon className="w-4 h-4 text-burgundy" data-id="element-146" />
                <span data-id="element-147">Acceso inmediato</span>
              </div>
              <div className="flex items-center gap-1.5" data-id="element-148">
                <CreditCardIcon className="w-4 h-4 text-burgundy" data-id="element-149" />
                <span data-id="element-150">Todas las tarjetas</span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Decorative elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/10 rounded-full filter blur-3xl translate-x-1/2 -translate-y-1/2" data-id="element-151"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-gold/10 rounded-full filter blur-3xl -translate-x-1/2 translate-y-1/2" data-id="element-152"></div>
    </section>;
}